// app/src/lib/index.js — public entry for the Crew browser library.
// Bundled by vite.lib.config.js into app/dist/crew-lib.js, exposed as `window.crew`.

import * as cryptoLib from './crypto.js';
import * as tokenStore from './tokenStore.js';
import * as auth from './auth/cognitoClient.js';
import { configure, getConfig } from './config.js';
import { api } from './api.js';
import * as localCache from './localCache.js';
import * as subscription from './billing/subscription.js';
import * as plan from './billing/plan.js';
import * as finixForm from './billing/finixForm.js';

/**
 * Public surface. Keep small and stable — the React components depend on it.
 * @namespace crew
 */
const crew = Object.freeze({
  configure,
  getConfig,
  crypto: cryptoLib,
  tokenStore,
  auth,
  api,
  localCache,
  billing: { subscription, plan, finixForm },
  // Mutable app-state holder. The crew namespace is frozen (shallow), so app code
  // must write runtime state HERE (e.g. crew.state.me, crew.state.activeWorkplaceId)
  // — assigning new props directly on `crew` silently no-ops on the frozen object.
  state: {},
});

if (typeof window !== 'undefined') window.crew = crew;
export default crew;
